export default function LearnMore() {
  return (
    <section className="section-padding bg-white">
      <div className="container-custom">
        <div className="max-w-3xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Learn More
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            Get more information about Harbor Agent and connect with our team
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://gentlyventures.com/products/harbor-agent"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary text-lg px-8 py-4"
            >
              Gently Ventures Product Page
            </a>
            <a
              href="mailto:support@gentlyventures.com"
              className="btn-secondary text-lg px-8 py-4"
            >
              Contact Support
            </a>
          </div>
        </div>
      </div>
    </section>
  )
}

